import styled from 'styled-components';
import Link from './Link';

export const TabsNav = styled.nav`
  --tablink-active-color: var(--blurple);
  --tablink-resting-color: var(--pleather);

  display: flex;
  flex-direction: row;
  background-color: var(--white);
  box-shadow: var(--level-1);

  ${({ sticky }) =>
    sticky &&
    `
      position: sticky;
      top: 100px;
      z-index: 1;
    `}
`;

export const TabsList = styled.ol``;

export const TabItem = styled.li`
  display: inline-block;
  min-width: 200px;
  padding: 18px 0;
  text-align: center;

  ${({ $active }) =>
    $active &&
    `
      border-bottom: 2px solid var(--tablink-active-color);

      ${Link} {
        color: var(--tablink-active-color);
      }
    `}

  ${Link} {
    --link-color: var(--tablink-resting-color);
    --link-text-decoration: none;
    --link-hover-color: var(--tablink-active-color);
    --link-visited-color: var(--link-color);
  }
`;
